// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"f31146e7","297":"3d60136d","643":"2cb49def","787":"11745f45"}[chunkId] + ".chunk.js";
};